import { APP_TITLE_CHANGE } from '../actions/LayoutActions';

const INIT_STATE = {
  AppTitle: 'Extranet',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case APP_TITLE_CHANGE: {
      return { ...state, AppTitle: action.payload };
    }
    default:
      return state;
  }
};
